import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

import LoadingSpinner from '../../partials/LoadingSpinner';
import PageHeader from '../../partials/PageHeader';
import SuggestionItemsModal from './SuggestionItemsModal';

// import { locationsIndex } from '../../../redux/actions/locations';
import { suppliersIndex } from '../../../redux/actions/suppliers';
import { createSuggestedPurchaseOrder, suggestedPurchaseOrdersIndex, findSuggestedPurchaseOrder } from '../../../redux/actions/suggestedPurchaseOrders';


const Suggestions = ({ payload, suppliers, suggestedPurchaseOrders, loadSuppliers, loadSuggestions, loadSuggestedOrder, newSuggestion }) => {
  const [showCreateSuggestionModal, setShowCreateSuggestionModal] = useState(false);
  // const [activeAddress, setActiveAddress] = useState(null);
  const [activeSupplier, setActiveSupplier] = useState(null);
  const [showSuggestionItemsModal, setShowSuggestionItemsModal] = useState(false);
  const [existsError, setExistsError] = useState(null);

  const [page, setPage] = useState(0);

  useEffect(() => {
    loadSuppliers(payload);
    // loadLocations(payload);
    loadNextSuggestedPurchaseOrders();
  }, []);


  const showItemsModal = (suggestedPurchaseOrderId) => {
    loadSuggestedOrder(payload, suggestedPurchaseOrderId);
    setShowSuggestionItemsModal(true);
  }

  const createSuggestion = () => {
    console.log(activeSupplier);

    newSuggestion(payload, activeSupplier);
  }

  const checkExisting = (location, supplier) => {
    let currentDate = new Date();
    const offset = currentDate.getTimezoneOffset();
    let existing = suggestedPurchaseOrders.suggestedPurchaseOrders.find(spo => (spo.location_id === location?.id) && (spo.supplier_id === supplier?.id) && (spo.suggestion_date === (new Date(currentDate.getTime() - (offset*60*1000)).toISOString().split('T')[0])) )

    setExistsError(!!existing);
  }

  // const activateAddress = (location) => {
  //   setActiveAddress(location);
  //   checkExisting(location, activeSupplier);
  // }

  const activateSupplier = (supplier) => {
    console.log(supplier);

    setActiveSupplier(supplier);
    checkExisting(supplier);
  }

  const loadPreviousSuggestedPurchaseOrders = () => {
    let previousContinuationToken = suggestedPurchaseOrders.purchaseOrdersSearchStack[page - 2];
    loadSuggestions(payload, previousContinuationToken, (page - 1));

    setPage(page - 1);
  }

  const loadNextSuggestedPurchaseOrders = () => {
    loadSuggestions(payload, suggestedPurchaseOrders.purchaseOrdersSearchStack[page], (page + 1));
    setPage(page + 1);
  }

  return(
    <>
      <PageHeader stripeBackground='#5bc6cc' helpLink="ecwid/manage-suggested-purchase-orders-2/" />
      <div className="settings-page cf">
        <div className="settings-page__header">
          <div className="named-area">
            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title">Suggest New Purchase Order</div>
              </div>
              <div className="named-area__description">
                <p>Select a location and supplier to generate a suggested purchase order based on thresholds set in the "Set Thresholds" tool.</p>
                <p>Only one suggestion can be generated per day, per location and supplier combination. Suggestions are kept for 2 days before being removed.</p>
              </div>
            </div>

            <div className="named-area__body">
              <div className="a-card-stack">
                
                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">

                    { suppliers.suppliers.length > 0 && suppliers.status === 'success' &&
                      <div className="flex-1">
                        <h4>Supplier</h4>

                        <div className="fieldset fieldset--select">
                          <div className="field field--medium field--filled">
                            <label className="field__label">Select Supplier</label>
                            <select className="field__select" onChange={(e) => activateSupplier(e.target.value)}>
                              <option hidden disabled selected value></option>
                              { suppliers.suppliers.map(supplier => 
                                <option value={supplier.id} key={supplier.id}>{supplier.supplier_name}</option>
                              )}
                            </select>
                            <div className="field__placeholder">Select Supplier</div>
                          </div>
                        </div>


                      </div>
                    }

                    { suppliers.suppliers.length === 0 && !suppliers.isFetching &&
                      <div className="a-card a-card--vertical-compact a-card--info a-card--info-blue">
                        <div className="a-card__paddings text-center">
                          <p>No suppliers available. Add supplier information to see suppliers in a dropdown list here.</p>
                          <Link to="/suppliers">
                            <button
                              className="btn btn-default"
                            >
                              Manage Suppliers
                            </button>
                          </Link>
                        </div>
                      </div>
                    }

                    { suppliers.status !== 'success' &&
                      <LoadingSpinner statusText="Loading suppliers" />
                    }

                  </div>
                </div>


                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">
                    <button
                      className="btn btn-primary btn-medium"
                      disabled={!activeSupplier || suggestedPurchaseOrders.isUpdating || existsError}
                      isLoading={suggestedPurchaseOrders.isUpdating}
                      onClick={() => createSuggestion()}
                    >
                      <span className="svg-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="150" height="150" fill="#000000" viewBox="0 0 32 32">
                          <g>
                            <path className="st0" d="M17.9,9.9c-4.6,0.9-6,2.3-6.9,6.9c-0.9-4.6-2.3-6-6.9-6.9C8.7,9,10.1,7.6,11,3C11.9,7.6,13.3,9,17.9,9.9z"/>
                          </g>
                          <g>
                            <path className="st0" d="M21.8,25c-3.2,0.6-4.1,1.6-4.8,4.8c-0.6-3.2-1.6-4.1-4.8-4.8c3.2-0.6,4.1-1.6,4.8-4.8
                              C17.6,23.4,18.6,24.4,21.8,25z"/>
                          </g>
                          <g>
                            <path className="st0" d="M29,15c-2.6,0.5-3.4,1.3-3.9,3.9c-0.5-2.6-1.3-3.4-3.9-3.9c2.6-0.5,3.4-1.3,3.9-3.9C25.6,13.7,26.4,14.5,29,15
                              z"/>
                          </g>
                          <line className="st0" x1="5" y1="23" x2="5" y2="23"/>
                          <line className="st0" x1="28" y1="6" x2="28" y2="6"/>
                        </svg>
                      </span>
                      <span className="gwt-InlineLabel">Suggest Purchase Order</span>
                    </button>

                    { existsError && 
                      <p>
                        A suggested purchase order already exists for this supplier for today.
                      </p>
                    }

                    { suggestedPurchaseOrders.errors &&
                      <p>
                        {suggestedPurchaseOrders.errors}
                      </p>
                    }
                    { !activeSupplier &&
                      <p>
                        <span className="text-default warning">
                          Select a supplier to suggest purchase order
                        </span>
                      </p>
                    }

                  </div>
                </div>

              </div>
            </div>
          </div>



          <div className="named-area">
            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title">Suggested Purchase Orders</div>
              </div>
              <div className="named-area__description">
                
              </div>
            </div>

            <div className="named-area__body">
              <div className="a-card-stack">


                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">
                    { !(suppliers.status === 'success' && !suggestedPurchaseOrders.isFetching) &&
                      <LoadingSpinner statusText="Loading suppliers" />
                    }

                    { (suppliers.status === 'success' && !suggestedPurchaseOrders.isFetching) &&
                      <>
                        <div className="flex-container">
                          <div className="flex-1">
                            <button
                              className="btn btn-default btn-medium"
                              onClick={() => loadPreviousSuggestedPurchaseOrders()}
                              disabled={page === 1}
                            >
                              <span className="svg-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.284 9.9992H15c.5523 0 1-.4477 1-1 0-.5522-.4477-1-1-1H5.284l2.7725-3.0035c.3746-.4059.3493-1.0385-.0565-1.4131-.4058-.3746-1.0385-.3493-1.413.0565L2.2651 8.321a1 1 0 0 0 0 1.3565l4.3217 4.6819c.3746.4058 1.0073.4311 1.4131.0565.4058-.3746.4311-1.0072.0565-1.4131L5.284 9.9992z"/></svg>
                              </span>
                              <span className="gwt-InlineLabel">Previous Suggested Purchase Orders</span>
                            </button>

                            <button
                              className="btn btn-default btn-medium"
                              onClick={() => loadNextSuggestedPurchaseOrders()}
                              disabled={suggestedPurchaseOrders.lastPage}
                            >
                              <span className="gwt-InlineLabel">Next Suggested Purchase Orders</span>
                              <span className="svg-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.716 9.9992H3c-.5523 0-1-.4477-1-1 0-.5522.4477-1 1-1h9.716L9.9435 4.9958c-.3746-.4059-.3493-1.0385.0565-1.4131.4058-.3746 1.0385-.3493 1.4131.0565l4.3217 4.6819a1 1 0 0 1 0 1.3565l-4.3217 4.6819c-.3746.4058-1.0073.4311-1.4131.0565-.4058-.3746-.4311-1.0072-.0565-1.4131l2.7725-3.0036z"/></svg>
                              </span>
                            </button>
                          </div>
                        </div>
                        <br/>

                        { suggestedPurchaseOrders.isFetching &&
                          <LoadingSpinner statusText="Loading Purchase Orders" />
                        }

                        { suggestedPurchaseOrders.suggestedPurchaseOrders.length === 0 && !suggestedPurchaseOrders.isFetching &&
                          <div className="a-card a-card--vertical-compact a-card--info a-card--info-blue">
                            <div className="a-card__paddings text-center">
                              <p>No outstanding suggested purchase orders. Create suggested purchase orders to see them in a list here.</p>
                            </div>
                          </div>
                        }

                        
                      </>
                    }

                  </div>
                </div>

                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">
                    { (suppliers.status === 'success' && !suggestedPurchaseOrders.isFetching) &&
                      <>
                        { suggestedPurchaseOrders.suggestedPurchaseOrders.map(suggestedPurchaseOrder =>
                          <>
                            <h3>{suggestedPurchaseOrder.suggestion_date} - {suppliers?.suppliers?.find(supp => supp.id === suggestedPurchaseOrder.supplier_id)?.supplier_name}</h3>
                            <div className="flex-container">
                              <div className="flex-1">
                                <ul>
                                  <li><strong>Suggestion Date</strong>: <span className="inline-text-tag inline-text-tag--light-half">{suggestedPurchaseOrder.suggestion_date}</span> </li>
                                  <li><strong>Supplier</strong>: <span className="inline-text-tag inline-text-tag--light-half">{suppliers?.suppliers?.find(supp => supp.id === suggestedPurchaseOrder.supplier_id)?.supplier_name}</span></li>
                                </ul>
                              </div>
                              <div className="flex-1">
                                <strong>Status</strong>: <span className={`inline-text-tag ${suggestedPurchaseOrder.status === 'ready' ? 'inline-text-tag--success' : 'inline-text-tag--warning'}`}>{suggestedPurchaseOrder.status}</span>
                                { suggestedPurchaseOrder.status !== 'ready' && suggestedPurchaseOrder.status !== 'complete' && suggestedPurchaseOrder.status !== 'empty' &&
                                  <button className="btn btn-link btn-medium" onClick={() => loadSuggestions(payload, suggestedPurchaseOrders.purchaseOrdersSearchStack[page - 1], page)}>
                                    <span className="svg-icon">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M3.2482 7.2852C3.986 4.8062 6.2833 3 8.9999 3c1.6791 0 3.1956.6884 4.2857 1.801l.0126.0128.1964.1864h-.4008C12.5415 5 12.0937 5.4476 12.0937 6c-.0001.5523.4476 1 .9999 1.0001l2.938.0005c.5524 0 1.0002-.4477 1.0002-1V2.742c0-.5522-.4477-1-1-1s-1 .4478-1 1v.9598l-.3307-.314C13.2511 1.915 11.2315 1 8.9999 1 5.3744 1 2.3146 3.4109 1.3313 6.7148c-.1575.5293.1439 1.0861.6732 1.2436.5293.1576 1.0862-.1438 1.2437-.6732zM16.6684 11.2852c.1576-.5293-.1438-1.0861-.6732-1.2437-.5293-.1575-1.0861.1439-1.2437.6733C14.0137 13.1939 11.7164 15 8.9999 15c-1.6791 0-3.1956-.6884-4.2858-1.8009l-.0126-.0129-.195-.1851h.4082c.5522 0 1-.4478 1-1 0-.5523-.4478-1-1.0001-1L2 11.0012c-.5523 0-1 .4477-1 1v3.087c0 .5523.4477 1 1 1s1-.4477 1-1v-.7596l.2987.2836C4.7487 16.085 6.7683 17 8.9999 17c3.6255 0 6.6853-2.4109 7.6685-5.7148z"/></svg>
                                    </span>
                                    <span className="gwt-InlineLabel">Refresh Status</span>
                                  </button>
                                }

                                { suggestedPurchaseOrder.status === 'ready' &&
                                  <>
                                    <br/>
                                    <br/>
                                    <button
                                      className="btn btn-default btn-medium"
                                      onClick={() => showItemsModal(suggestedPurchaseOrder.id)}
                                    >
                                      <span className="svg-icon">
                                        <svg aria-hidden="true" fill="currentColor" height="24" stroke="currentColor" stroke-width="0" viewBox="0 0 24 24" width="24" className="base__StyledIcon-sc-a9u0e1-0 emfseH"><path d="M0 0h24v24H0z" fill="none"></path><path d="M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4m0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"></path></svg>
                                      </span>
                                      <span className="gwt-InlineLabel">View Suggested Order Items</span>
                                    </button>
                                    <br/>
                                    <br/>

                                    <Link to={`/purchase_order/suggestion/${suggestedPurchaseOrder.id}`}>
                                      <button
                                        className="btn btn-primary-accent btn-medium"
                                      >
                                        <span className="svg-icon">
                                          <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9"><path d="M5 4V2.5a.5.5 0 1 0-1 0V4H2.5a.5.5 0 1 0 0 1H4v1.5a.5.5 0 1 0 1 0V5h1.5a.5.5 0 1 0 0-1H5z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8 1H1v7h7V1zM1 0C.4477 0 0 .4477 0 1v7c0 .5523.4477 1 1 1h7c.5523 0 1-.4477 1-1V1c0-.5523-.4477-1-1-1H1z"/></svg>
                                        </span>
                                        <span className="gwt-InlineLabel">Create Suggested Purchase Order</span>
                                      </button>
                                    </Link>
                                  </>
                                }
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    }
                  </div>
                </div>

              </div>
            </div>

          </div>

        </div>
      </div>

      { showSuggestionItemsModal &&
        <SuggestionItemsModal
          payload={payload}
          showSuggestionItemsModal={showSuggestionItemsModal}
          setShowSuggestionItemsModal={setShowSuggestionItemsModal}
          suggestedPurchaseOrder={suggestedPurchaseOrders.activeSuggestedPurchaseOrder}
        />
      }
    </>
  )
}

const mapStateToProps = state => ({
  suppliers: state.suppliers,
  suggestedPurchaseOrders: state.suggestedPurchaseOrders
});

const mapDispatchToProps = (dispatch) => ({
  loadSuppliers: (payload) => dispatch(suppliersIndex(payload)),
  loadSuggestions: (payload, continuationToken, page) => dispatch(suggestedPurchaseOrdersIndex(payload, continuationToken, page)),
  loadSuggestedOrder: (payload, suggestedOrderId) => dispatch(findSuggestedPurchaseOrder(payload, suggestedOrderId)),
  newSuggestion: (payload, supplier) => dispatch(createSuggestedPurchaseOrder(payload, supplier))
});

export default connect(mapStateToProps, mapDispatchToProps)(Suggestions);